import { buildPageHead } from "@lib/meta"
import * as m from "@paraglide/messages"
import { SiteShell } from "@shared/ui/SiteShell"
import type { SupportedLocale as Lang } from "@site-types/content"
import { createFileRoute } from "@tanstack/react-router"

export const Route = createFileRoute("/$locale/500")({
  head: ({ params }) => {
    const locale = params.locale as Lang
    return buildPageHead({
      locale,
      path: `/${locale}/500`,
      title: m.error_500_meta_title({}, { locale: locale }),
      description: m.error_500_description({}, { locale: locale }),
      stage: "dev",
    })
  },
  component: RouteComponent,
})

function RouteComponent() {
  const { locale: routeLocale } = Route.useParams()
  const locale = routeLocale as Lang

  return (
    <SiteShell
      page={m.error_500_meta_page({}, { locale: locale })}
      title={m.error_500_meta_pageTitle({}, { locale: locale })}
    >
      <div
        className="mx-auto min-h-[calc(100lvh-51px)] max-w-[600px] pt-[5%] text-center"
        data-testid="page-error"
      >
        <h1 className="text-[34px]">{m.error_500_label({}, { locale: locale })}</h1>
        <div>
          <p>{m.error_500_description({}, { locale: locale })}</p>
        </div>
        <a href={`/${locale}`}>{m.back_toHome({}, { locale: locale })}</a>
      </div>
    </SiteShell>
  )
}
